const GOOGLE_ANALYTICS_ID = "5e542b3a4cd8884eb41b5a72";

type VendorConsents = {
  consentedVendors: Array<{ _id: string }>;
};

const hasConsent = (vendorConsents: VendorConsents, ID: string) =>
  vendorConsents.consentedVendors.some(
    (vendor: { _id: string }) => vendor._id === ID,
  );

function getVendorConsentData() {
  return new Promise((resolve, reject) => {
    if (typeof window.__tcfapi !== "function") {
      return reject(new Error("__tcfapi is not defined"));
    }
    window.__tcfapi(
      "getCustomVendorConsents",
      2,
      (vendorConsents: VendorConsents, successForConsent: boolean) => {
        if (successForConsent) {
          const hasGAConsent = hasConsent(vendorConsents, GOOGLE_ANALYTICS_ID);

          resolve(hasGAConsent);
        } else {
          resolve(false);
        }
      },
    );
  });
}

export async function prepareEventData(form: EventTarget & HTMLFormElement) {
  const formData = new FormData(form);
  const data = Object.fromEntries(formData.entries());

  const querydata: {
    the_buzz_search_text?: FormDataEntryValue;
    the_buzz_search_tags?: FormDataEntryValue;
  } = {};

  if (data.search) {
    querydata.the_buzz_search_text = data.search;
  }

  if (data.search) {
    querydata.the_buzz_search_tags = data.search;
  }

  return querydata;
}

export async function pushEvent(form: EventTarget & HTMLFormElement) {
  const querydata = prepareEventData(form);

  sendEvent("search", querydata);
}

export async function sendEvent(
  eventName: string,
  params: Record<string, any> = {},
) {
  const hasGoogleAnalyticsConsent = await getVendorConsentData();

  if (hasGoogleAnalyticsConsent === true) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...params });
  }
}
